import { useEffect } from 'react';

import Topbar from '../components/Topbar';

import { Row, Col, Card, Image } from 'react-bootstrap';

import { selectRoom } from '../redux/slices/roomsSlice';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import '../styles/roomStyles.css';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import RoomPreview from '../components/RoomPreview';

import phone from '../assets/PhoneBright.svg'
import mail from '../assets/MailBright.svg'
import pin from '../assets/PinBright.svg'

const RoomPage = () => {
  const room = useSelector(selectRoom);

  const aboutData = {
      id: 0,
      email: 'info@gemluxury.eu',
      phoneNumber: '+30 69 8314 5847',
      location: 'Σμύρνης 18, 68100 Νέα Χηλή'
  }

  const { t } = useTranslation()
  const navigate = useNavigate();
  
  // Handle Responsiveness
  useEffect(() => {
    window.scrollTo(0,0)
  }, []);


  useEffect(() => {
    if (!room.title) {
      navigate('/');
    }
  }, [room.title, navigate]);

  return (
    <>
      <Topbar color={room.color}/>

      <Row className="d-flex justify-content-center" style={{marginTop: '5rem'}}>
        {/* Carousel Section */}
        <Col xs={11} lg={4} style={{margin: '1rem'}}>
          <RoomPreview key={room.id} {...room} mode="single"/> 
        </Col>

        <Col xs={11} lg={4} style={{margin: '1rem'}}>
          <Card className="bg-white shadow-sm d-flex">
            <Card.Body>
              <h4 style={{ fontWeight: 'bold', margin: '.5rem 1rem' }}>{t('facilities')}</h4>
              
              <Row className="d-flex justify-content-between">
                {/* Room Facilities Section */}
                <Col className="col-auto">
                  <div className="roomNameWrapper">
                    <ul style={{ listStyleType: 'disc', paddingLeft: '2rem', color: '#666' }}>
                      {room?.facilities?.map((service) => (
                        <li key={service}>{service}</li>
                      ))}
                    </ul>
                  </div>
                </Col>

               
              </Row>
            </Card.Body>
          </Card>

          <Card className="bg-white shadow-sm d-flex mt-4">
            <Card.Body>
                      <div className="roomNameWrapper">
                            <Row className="justify-content-center">
                                <Col xs={2} sm={1} md={2} lg={2} xl={1}>
                                    <Image src={phone} style={{color: '#666', fontWeight: '400', height: '2rem', marginTop: '1rem', marginRight: '1rem'}} alt="AboutUsCardItemContactPhoneIcon"/>
                                </Col>
                                <Col xs={6} lg={10}>
                                    <h5 style={{color: '#666', cursor: 'pointer', marginTop: '1rem'}} onClick={() => window.open(`tel:${aboutData.phoneNumber}`)}>{aboutData.phoneNumber}</h5>
                                </Col>
                            </Row>
                            <Row className="justify-content-center align-items-center">
                                <Col xs={2} sm={1} md={2} lg={2} xl={1}>
                                    <Image src={pin} style={{color: '#666', fontWeight: '400', height: '2rem', marginTop: '1rem', marginRight: '1rem'}} alt="AboutUsCardItemContactLocation"/>
                                </Col>
                                <Col xs={6} lg={10}>
                                    <h5 style={{color: '#666', cursor: 'pointer', marginTop: '1rem'}} onClick={() => window.open(`https://maps.app.goo.gl/xfhDjfZQTdwBUKzR6`)}>{aboutData.location}</h5>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col xs={2} sm={1} md={2} lg={2} xl={1}>
                                    <Image src={mail} style={{color: '#666', fontWeight: '400', height: '2rem', marginTop: '1rem', marginRight: '1rem'}} alt="AboutUsCardItemContactEmailIcon"/>
                                </Col>
                                <Col xs={6} lg={10}>
                                    <h5 style={{color: '#666', cursor: 'pointer', marginTop: '1rem'}} onClick={() => window.open(`https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=CllgCJZWxJkXvQZtWsQCgDKFNFnxTqrrMSqTxQwDPMDhcXKmNkWTStJNXMVVZBfMsVdlctcPvhg`, '_blank')}>{aboutData.email}</h5>
                                </Col>
                            </Row>
                        </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>


      <Footer />
    </>
  );
};

export default RoomPage;

